<div [ngClass]="[heightStyleMain]">
  <canvas id="graph1" [hidden]="!graph">{{graph}}</canvas>
</div>
@if (secondGraphShow) {
  <div [ngStyle]="{'display': isOctopus ? 'none' : 'block'}" [ngClass]="heightStyleMini">
    @if (loading2) {
      <lds-progress-spinner></lds-progress-spinner>
    }
    <canvas id="miniGraph" [hidden]="loading2">{{miniGraph}}</canvas>
  </div>
}
<div class="below-graph">
  <button id="reset-graph-button" class="lds-btn active" (click)="resetGraph()">Reset Graph</button>
</div>